if (!customElements.get('dynamic-image-text')) {
  class DynamicImageText extends HTMLElement {
    constructor() {
      super();

      this.accordionTriggers = this.querySelectorAll('.js-accordion-trigger');
      this.imageWrappers = this.querySelectorAll('.js-dynamic-image');
      this.accordionItems = this.querySelectorAll('.js-accordion-item');
      this.accordionContents = this.querySelectorAll('.js-accordion-content');
    }

    connectedCallback() {
      this.bindEvents();
    }

    disconnectedCallback() {
      this.cleanup();
    }

    bindEvents() {
      this.accordionTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleAccordionClick(trigger);
        });
      });
    }

    handleAccordionClick(clickedTrigger) {
      const clickedItem = clickedTrigger.closest('.js-accordion-item');
      const content = clickedItem.querySelector('.js-accordion-content');
      const isCurrentlyOpen = clickedItem.classList.contains('is-active');
      
      this.closeAllAccordions();
      
      if (!isCurrentlyOpen) {
        this.openAccordion(clickedItem, clickedTrigger, content);
      }
      
      this.switchImage(clickedTrigger);
    }

    openAccordion(item, trigger, content) {
      item.classList.add('is-active');
      content.classList.add('is-active');
      
      trigger.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
      
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    closeAllAccordions() {
      this.accordionItems.forEach(item => {
        const trigger = item.querySelector('.js-accordion-trigger');
        const content = item.querySelector('.js-accordion-content');
        
        item.classList.remove('is-active');
        content.classList.remove('is-active');
        
        trigger.setAttribute('aria-expanded', 'false');
        content.setAttribute('aria-hidden', 'true');
        
        content.style.maxHeight = '0px';
      });
    }

    switchImage(trigger) {
      const accordionTitle = trigger.dataset.accordionTitle;
      
      this.imageWrappers.forEach(wrapper => {
        wrapper.classList.remove('is-active');
      });
      
      this.imageWrappers.forEach(wrapper => {
        const wrapperTitle = wrapper.dataset.accordionTitle;
        if (wrapperTitle === accordionTitle) {
          wrapper.classList.add('is-active');
        }
      });
    }

    cleanup() {
      this.accordionTriggers.forEach(trigger => {
        trigger.removeEventListener('click', (e) => {
          e.preventDefault();
          this.handleAccordionClick(trigger);
        });
      });
    }
  }

  customElements.define('dynamic-image-text', DynamicImageText);
}
